import axios from '@/libs/api.request'
export const google2afStatus = async (that, data) => {
    var res = await axios.request({
        url: '/shop/totp/qrcode',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const agreeBound = async (that, data) => {
    var res = await axios.request({
        url: '/shop/totp/agreeBound',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}

